export var InteractionState;
(function (InteractionState) {
    InteractionState["Blocked"] = "BLOCKED";
    InteractionState["Complete"] = "COMPLETE";
    InteractionState["Deflecting"] = "DEFLECTING";
    InteractionState["Handling"] = "HANDLING";
    InteractionState["Queuing"] = "QUEUING";
    InteractionState["WrapUp"] = "WRAP_UP";
})(InteractionState || (InteractionState = {}));
export var TextSearchType;
(function (TextSearchType) {
    TextSearchType["Simple"] = "simple";
    TextSearchType["Vector"] = "vector";
})(TextSearchType || (TextSearchType = {}));
//# sourceMappingURL=interactions.js.map